import React, { useRef, useCallback, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import ButtonComponent from "../../../Components/Common/button/Button";
import { MessagePopup } from "../../../Components/Common/messagePopup/MessagePopup";
import ApiService from "../../../utils/fetch";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";

const CIExcelUpdate = () => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = useCallback(async (event) => {
    if (isUploading) return;
    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: "Please select a file!",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true);
    try {
      const response = await ApiService.upload(
        "/v1/custom-conc-inventory/template-upload",
        formData
      );

      if (response.status === 200) {
        MessagePopup({
          icon: "success",
          title: "Success!",
          message: response.data?.message || "File uploaded successfully!",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to upload file. Please ensure the file contains valid data.";
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: errorMessage,
      });
    } finally {
      setIsUploading(false);
    }
  }, []);

  const DownloadTemplate = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await ApiService.CustomDownloadFile(
        "/v1/custom-conc-inventory/generate-template"
      );
      if (response.status === 200 && response.data) {
        // Create an object URL for the Blob
        const url = window.URL.createObjectURL(response.data);

        // Generate a timestamp for the filename (optional)
        const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");

        // Set the filename for the download
        const filename = `ExcelUpdate_${timestamp}1.xlsx`;

        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the document body, click it, then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the object URL to release memory
        URL.revokeObjectURL(url);

        MessagePopup({
          icon: "success",
          message: "Excel file downloaded successfully!",
        });
      }
    } catch (error) {
      const errorMessage =
        // error.response?.data ||
        "Failed to Download file.";
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: errorMessage,
      });
    } finally {
      setLoading(false); // Always stop loader
    }
  };

  const handleUploadClick = useCallback(() => {
    fileInputRef.current.click();
  }, []);

  return (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Download Mapping Configuration
          </Typography>
          <ButtonComponent
            maxWidth="150px"
            label={loading ? "Processing..." : "Download"}
            bgColor="black"
            color="white"
            onClick={DownloadTemplate}
            disabled={loading}
            startIcon={<DownloadIcon />}
          />
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              border: "2px dashed #ccc",
              borderRadius: 2,
              p: 4,
              textAlign: "left",
              backgroundColor: "#fafafa",
              width: "fit-content",
            }}
          >
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              Upload the File for Processing
            </Typography>
            <input
              type="file"
              ref={fileInputRef}
              accept=".xlsx, .xls"
              style={{ display: "none" }}
              id="excel-upload"
              onChange={handleFileUpload}
            />
            <label htmlFor="excel-upload">
              <ButtonComponent
                component="span"
                maxWidth="150px"
                label={isUploading ? "Uploading..." : "Excel Upload"}
                bgColor="black"
                color="white"
                //onClick={handleUploadClick}
                onClick={() => {
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                    fileInputRef.current.click();
                  }
                }}
                disabled={isUploading}
                startIcon={<FileUploadIcon />}
              />
            </label>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              The file should be in .xlsx format
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CIExcelUpdate;
